// セッションストレージのキー
const USER_PERMISSIONS_KEY = 'userPermissions';

// システムロールのプレフィックス
const SYSTEM_ROLE_PREFIX = 'system-role';

/**
 * キャッシュされた権限情報を取得する
 * @returns {Object|null} 権限オブジェクト、存在しない場合はnull
 */
export function getPermissions(): Permissions | null {
  const permissionsStr = sessionStorage.getItem(USER_PERMISSIONS_KEY);
  if (!permissionsStr) return null;
  return JSON.parse(permissionsStr);
}

/**
 * システムロールかどうかを判定する
 * @param roleId ロールID
 * @returns システムロールの場合true
 */
export function isSystemRole(roleId: string): boolean {
  return roleId.startsWith(SYSTEM_ROLE_PREFIX);
}
